var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.state)+" "),(_vm.type != 'audio')?_c('video',{ref:"player",attrs:{"autoplay":"","playsinline":""}}):_vm._e(),(_vm.type === 'audio')?_c('video',{ref:"player",attrs:{"autoplay":"","playsinline":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }